/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import {
  T積卸先,
  TTumiorosisakiListGetReq,
  TTumiorosisakiListGetRes,
} from "../../service/master/tumiorosisaki/TTumiorosisaki"
import TumiorosisakiService from "../../service/master/tumiorosisaki/tumiorosisakiService"

import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"
// import { TodohukenAutoComplete } from "../ComboBox/TodohukenAutoComplete"
// import { T都道府県 } from "../ComboBox/TodohukenComboBox"
import EmptyTextHeader from "../FlexGridWrapper/EmptyTextHeader"
import GridFooter from "../FlexGridWrapper/GridFooter"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"

import Spinner from "../Spinner"

// TODO:仕掛中
/**
 * 積卸先情報検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const TumiOrosiSakiSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    syamei?: string
    todohuken?: string
    sikutyoson?: string
    ninusiCode?: string
    isNinusiReadOnly?: boolean
    setTumiOrosiSaki: (value: T積卸先) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [荷主コード, set荷主コード] = useState<string>()
  const [荷主名, set荷主名] = useState<string>()
  const [積卸先コード, set積卸先コード] = useState<string>()
  const [積卸先名, set積卸先名] = useState<string>()
  const [住所１, set住所１] = useState<string>()
  const [住所２, set住所２] = useState<string>()
  // AutoComplete
  // 都道府県
  // const [都道府県AutoComplete, set都道府県AutoComplete] =
  //   useState<TWijmoAutoComplete<string, T都道府県> | null>(null)
  // const [都道府県IsLoadEnded, set都道府県IsLoadEnded] = useState<boolean>(false)

  // Grid
  const [pageSize, setPageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
      sortConverter: (
        sd: wjcCore.SortDescription,
        item: TTumiorosisakiListGetRes,
        value: any
      ) => {
        const property = sd.property as keyof TTumiorosisakiListGetRes

        if (property !== "積卸先コード") {
          return value
        }
        const code = value as string
        if (code == null) return code
        //数値変換できるコードは左0埋め、文字列含みは末尾Z埋めを行う
        if (isNaN(parseInt(code))) {
          return code.padEnd(15, " ")
        } else {
          return code.padStart(15, "0")
        }
      },
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    setFlexGrid(grid)
  }

  const search = async (searchCondition?: TTumiorosisakiListGetReq) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    if (flexGrid == null) return
    try {
      // TODO:積卸先マスタ検索にて利用する検索APIをそのまま使う
      const res = await new TumiorosisakiService().getList({
        荷主コード: searchCondition?.荷主コード,
        荷主名: searchCondition?.荷主名,
        積卸先コード: searchCondition?.積卸先コード,
        積卸先名: searchCondition?.積卸先名,
        住所１: searchCondition?.住所１, //都道府県
        住所２: searchCondition?.住所２, //市区町村
      })
      if (res.data) {
        const newData = createCollectionView([...res.data], pageSize)
        flexGrid.itemsSource = newData
        setGridData({ data: newData })
        flexGrid.refresh()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }
  /**
   * 選択ハンドラ
   * @param item
   */
  const submitHandler = (item: T積卸先) => {
    props.setTumiOrosiSaki(item)
    props.setIsShow(false)
  }
  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      console.log(props)
      //表示時
      props.syamei != null && set積卸先名(props.syamei)
      props.todohuken != null && set住所１(props.todohuken)
      props.ninusiCode != null && set荷主コード(props.ninusiCode)
      if (
        props.syamei != null ||
        props.todohuken != null ||
        props.ninusiCode != null
      ) {
        search({
          荷主名: props.syamei,
          荷主コード: props.ninusiCode,
        })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set積卸先名("")
      set住所１("")
      set住所２("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "積卸先検索"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row>
            <Col>
              <Table className="search-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "6rem" }}
                          isReadOnly={props.isNinusiReadOnly}
                          id="荷主コード"
                          name="荷主コード"
                          placeholder="荷主CD"
                          value={荷主コード}
                          maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                          setValue={(v) => {
                            set荷主コード(v)
                          }}></TextInput>
                        {/* <button
                          type="button"
                          className="icon-button"
                          onClick={() => {
                            setIs荷主検索Modal(true)
                          }}>
                          <FontAwesomeIcon
                            className="icon-button-inner"
                            icon={faSearch}
                          />
                        </button> */}
                        <TextInput
                          style={{ width: "20rem" }}
                          isReadOnly={props.isNinusiReadOnly}
                          id="荷主名"
                          name="荷主名"
                          placeholder="荷主名"
                          maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                          value={荷主名}
                          setValue={(v) => {
                            set荷主名(v)
                          }}></TextInput>
                      </div>
                    </td>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "7rem" }}
                          id="積卸先コード"
                          name="積卸先コード"
                          placeholder="積卸先CD"
                          value={積卸先コード}
                          maxLength={VALIDATE_CONSTANT.LENGTH.積卸先コード}
                          setValue={(v) => {
                            set積卸先コード(v)
                          }}></TextInput>
                        <TextInput
                          style={{ width: "20rem" }}
                          id="積卸先名"
                          name="積卸先名"
                          value={積卸先名}
                          setValue={set積卸先名}
                          maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                          placeholder="積卸先名"
                        />
                        <TextInput
                          style={{ width: "12rem" }}
                          id="都道府県"
                          name="都道府県"
                          value={住所１}
                          setValue={set住所１}
                          maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                          placeholder="都道府県"
                        />
                        <TextInput
                          style={{ width: "12rem" }}
                          id="市区町村名"
                          name="市区町村名"
                          value={住所２}
                          setValue={set住所２}
                          maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                          placeholder="市区町村"
                        />
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Button
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault()
                          search({
                            荷主コード,
                            荷主名,
                            積卸先コード,
                            積卸先名,
                            住所１,
                            住所２,
                          })
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                        検索
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </form>
        <Row>
          <Col style={{ height: "35rem" }}>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              style={{ height: "30rem" }}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                width={CONSTANT.GRID.COL_SIZE.COL_CODE_SIZE}
                header="選択"
                align={"center"}
                binding="積卸先id">
                <EmptyTextHeader></EmptyTextHeader>
                <wjrGrid.FlexGridCellTemplate
                  cellType={wjrGrid.CellTemplateType.Cell}
                  template={(context: TWijmoCellTemplateContext<T積卸先>) => (
                    <Button onClick={() => submitHandler(context.item)}>
                      選択
                    </Button>
                  )}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="荷主コード"
                width={80}
                header="荷主CD"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="荷主名"
                width={200}
                header="荷主名"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={100}
                header="積卸先CD"
                binding="積卸先コード"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="積卸先名"
                binding="積卸先略称"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="住所１"
                width={120}
                header="都道府県"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="住所２"
                width={120}
                header="市区町村"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="住所３"
                width={120}
                header="町名番地"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={200}
                header="備考"
                binding="備考"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
            <GridFooter
              pageSize={pageSize}
              setPageSize={setPageSize}
              gridData={gridData}
              isEnableExport={false}
              flexGrid={flexGrid}></GridFooter>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default TumiOrosiSakiSearchModal
